import axios from 'axios';
import storage from '@/xstorage'

function login(user) {
  return axios.post(`https://${process.env.VUE_APP_ENDPOINT_SERVICES_PROXY}/api/session-new/create`, user)
    .then(response => {
      if (response.status === 200 && response.data.status === 'success') {
        storage.onConnect()
          .then(() => { return storage.set('token', response.data.token) })
          .then(() => { return storage.set('roles', JSON.stringify(response.data.roles)) })
          .catch((err) => { console.log(err); });
      }
    });
}

function logout(user) {
  return axios.post(`https://${process.env.VUE_APP_ENDPOINT_SERVICES_PROXY}/api/session-new/destroy`, user)
    .then(response => {
      if (response.status === 200 && response.data.status === 'success') {
        storage.onConnect()
          .then(() => { return storage.del('token') })
          .then(() => { return storage.del('roles') })
          .catch((err) => { console.log(err); });
      }
    });
}

function register(user) {
  return axios.post(`https://${process.env.VUE_APP_ENDPOINT_SERVICES_PROXY}/api/services-new/auth/v1/register`, user)
}

function recover(user) {
  const params = {
    'email': user.email,
    'g-recaptcha-response': user.recaptcha,
    'return_url': `https://${process.env.VUE_APP_RETURN_URL}/authentication/reset-password`
  };

  return axios.post(`https://${process.env.VUE_APP_ENDPOINT_SERVICES_PROXY}/api/services-new/auth/v1/password/email`, params);
}

function reset(user) {
  const params = {
    'token': user.token,
    'password': user.password,
    'password_confirmation': user.password_confirmation
  };

  return axios.post(`https://${process.env.VUE_APP_ENDPOINT_SERVICES_PROXY}/api/services-new/auth/v1/password/reset`, params);
}

export default {
  login,
  logout,
  register,
  recover,
  reset
};
